/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useForm } from 'react-hook-form';
import useRefetchTags from '../../hooks/useRefetchTags';
import { buildFilterParams } from '../../utils/helpers';
import SubmitSection from '../Shared/CategoryPages/SubmitSection';
import useGetOswValueTags from '../../hooks/OneSongWonder/useGetOswValueTags';

const Filters = ({ handleFilterSongs, loading }) => {
  const { register, handleSubmit, reset } = useForm();

  const allTagTypesRefetchMapDefault = {};

  const { loading: tagsLoading, tags: valueTags } = useGetOswValueTags();

  const isLoading = loading || tagsLoading;

  const [handleClearFilters, handleTagChange] = useRefetchTags(
    allTagTypesRefetchMapDefault,
    'Songs'
  );

  const handleFilter = (data) => handleFilterSongs(buildFilterParams(data));

  return (
    <div className="main__container bg__blue-nile mt-0">
      <div className="assembly__songfinder">
        <div className="wonders__filter">
          <SubmitSection
            label="Values"
            ref={register}
            tags={valueTags}
            name="values"
            onClick={handleSubmit(handleFilter)}
            disabled={isLoading}
            reset={reset}
            handleTagChange={handleTagChange}
            handleClearFilters={() => {
              handleClearFilters();
              handleSubmit(handleFilterSongs({}));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Filters;
